import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';
// utils
import axios, { endpoints, fetcher } from 'src/utils/axios';

// ----------------------------------------------------------------------

export async function createPaymentSetting(post_data) {
  const response = await axios.post(endpoints.master.payment_settings.create, post_data);
  return response.data?.payment_settings || [];
}

// ----------------------------------------------------------------------

export function useGetPaymentSettings() {
  const URL = endpoints.master.payment_settings.list;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher);

  const memoizedValue = useMemo(
    () => ({
      paymentSettings: data?.payment_settings || [],
      paymentSettingsLoading: isLoading,
      paymentSettingsError: error,
      paymentSettingsValidating: isValidating,
      paymentSettingsEmpty: !isLoading && !data?.payment_settings?.length,
    }),
    [data?.payment_settings, error, isLoading, isValidating]
  );

  return memoizedValue;
}

// ----------------------------------------------------------------------

export function useGetPaymentSetting(productId) {
  const URL = productId ? [endpoints.product.details, { params: { productId } }] : null;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher);

  const memoizedValue = useMemo(
    () => ({
      product: data?.product,
      productLoading: isLoading,
      productError: error,
      productValidating: isValidating,
    }),
    [data?.product, error, isLoading, isValidating]
  );

  return memoizedValue;
}

// ----------------------------------------------------------------------

export function useSearchPaymentSettings(query) {
  const URL = query ? [endpoints.product.search, { params: { query } }] : null;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
    keepPreviousData: true,
  });

  const memoizedValue = useMemo(
    () => ({
      searchResults: data?.results || [],
      searchLoading: isLoading,
      searchError: error,
      searchValidating: isValidating,
      searchEmpty: !isLoading && !data?.results.length,
    }),
    [data?.results, error, isLoading, isValidating]
  );

  return memoizedValue;
}

// ----------------------------------------------------------------------

export function useGetPaymentCreditors() {
  const URL = endpoints.master.payment_settings.creditors;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher);

  const memoizedValue = useMemo(
    () => ({
      creditors: data?.creditors || [],
      creditorsLoading: isLoading,
      creditorsError: error,
      creditorsValidating: isValidating,
      creditorsEmpty: !isLoading && !data?.creditors?.length,
    }),
    [data?.creditors, error, isLoading, isValidating]
  );

  return memoizedValue;
}
